import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodCryptoChainNetwork = z.object({
  id: ZodTrimmedString.min(1),
  display_name: ZodTrimmedString.min(1),
});

export type CryptoChainNetwork = z.infer<typeof ZodCryptoChainNetwork>;
